import { createRouter, createWebHistory } from 'vue-router'

// 로그인 검증 가드
const requireAuth = (to, from, next) => {
  const custNm = sessionStorage.getItem('custNm')
  const custId = sessionStorage.getItem('custId')

  if (custNm && custId) {
    next()
  } else {
    alert('로그인이 필요한 서비스입니다.')
    next('/auth/login')
  }
}

// 비밀번호 변경 가드: 정상 로그인 또는 임시비밀번호 강제 변경 진입 허용
const requireAuthOrForceChange = (to, from, next) => {
  if (sessionStorage.getItem('forcePwChange') === 'true') {
    next()
    return
  }
  requireAuth(to, from, next)
}

const routes = [
  // 메인 페이지 (홈)
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  
  // 상품안내
  {
    path: '/info/so_c1010',
    name: 'ProductGuide',
    component: () => import('@/components/info/so_c1010.vue')
  },
  {
    path: '/info/so_c1020',
    name: 'LoanProcess', 
    component: () => import('@/components/info/so_c1020.vue')
  },
  {
    path: '/info/so_c1030',
    name: 'LoanPrecautions',
    component: () => import('@/components/info/so_c1030.vue')  
  },
  
  // 대출신청
  {
    path: '/loan/so_c2010',
    name: 'EligibleStocks',
    component: () => import('@/components/loan/so_c2010.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/loan/so_c2020', 
    name: 'LoanAmountInquiry',
    component: () => import('@/components/loan/so_c2020.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/loan/so_c2030',
    name: 'LoanApplication', 
    component: () => import('@/components/loan/so_c2030.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/loan/so_c2032',
    name: 'LoanApplicationForm',
    component: () => import('@/components/loan/so_c2032.vue'),
    beforeEnter: requireAuth
  },
    {
    path: '/loan/so_c2033',
    name: 'LoanAgreement',
    component: () => import('@/components/loan/so_c2033.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/loan/so_c2034',
    name: 'LoanSignature',
    component: () => import('@/components/loan/so_c2034.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/loan/so_c2035',
    name: 'LoanContract',
    component: () => import('@/components/loan/so_c2035.vue'),
    beforeEnter: requireAuth
  },
  
  // 추가대출
  {
    path: '/loan/so_c2040',
    name: 'AdditionalLoan',
    component: () => import('@/components/loan/so_c2040.vue'),
    beforeEnter: requireAuth
  },

  // 계좌운영규칙
  {
    path: '/account-rules/so_c3000',
    name: 'AccountRules',
    component: () => import('@/components/account-rules/so_c3000.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/account-rules/so_c3002',
    name: 'AccountRulesIntegrated',
    component: () => import('@/components/account-rules/so_c3002.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/account-rules/so_c3003',
    name: 'AccountRulesETF',
    component: () => import('@/components/account-rules/so_c3003.vue'),
    beforeEnter: requireAuth
  },
  {
    // Pro 통합 계좌운영규칙 (현행 단일 운영 상품). Prime(so_c3002)/Max(so_c3003)는 재오픈 대비 유지.
    path: '/account-rules/so_c3004',
    name: 'AccountRulesPro',
    component: () => import('@/components/account-rules/so_c3004.vue'),
    beforeEnter: requireAuth
  },
  // 마이페이지
  {
    path: '/mypage/so_c4010',
    name: 'LoanInfo',
    component: () => import('@/components/mypage/so_c4010.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/mypage/so_c4020',
    name: 'RepaymentAndTermination', 
    component: () => import('@/components/mypage/so_c4020.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/mypage/so_c4030',
    name: 'MaturityExtension',
    component: () => import('@/components/mypage/so_c4030.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/mypage/so_c4040',
    name: 'MyInquiryBoard',
    component: () => import('@/components/mypage/so_c4040.vue'),
    beforeEnter: requireAuth
  },
  
  // 고객센터
  {
    path: '/support/so_c5000',
    name: 'CustomerCenter',
    component: () => import('@/components/support/so_c5000.vue')
  },
  {
    path: '/support/so_c5010',
    name: 'FAQ',
    component: () => import('@/components/support/so_c5010.vue')
  },
  {
    path: '/support/so_c5020',
    name: 'Notices',
    component: () => import('@/components/support/so_c5020.vue')
  },
  {
    path: '/support/so_c5030',
    name: 'NoticeBoard',
    component: () => import('@/components/support/so_c5030.vue')
  },
  {
    path: '/support/so_c5040',
    name: 'InquiryWrite',
    component: () => import('@/components/support/so_c5040.vue'),
    beforeEnter: requireAuth
  },
  
  // 인증 
  {
    path: '/auth/login',
    name: 'Login',
    component: () => import('@/components/auth/Login.vue')
  },
  {
    path: '/auth/find-id',
    name: 'FindId',
    component: () => import('@/components/auth/FindId.vue')
  },
  {
    path: '/auth/find-password',
    name: 'FindPassword',
    component: () => import('@/components/auth/FindPassword.vue')
  },
  {
    path: '/auth/signup', 
    name: 'Signup',
    component: () => import('@/components/auth/Signup.vue')
  },
  {
    path: '/auth/privacy',
    name: 'Privacy',
    component: () => import('@/components/auth/Privacy.vue')
  },
  {
    path: '/auth/terms',
    name: 'Terms',
    component: () => import('@/components/auth/terms.vue')
  },
  // 비밀번호 변경
  {
    path: '/auth/change-password',
    name: 'AuthChangePassword',
    component: () => import('@/components/auth/auth-change-password.vue'),
    beforeEnter: requireAuthOrForceChange
  },
  // 프로필 수정
  {
    path: '/auth/edit-profile',
    name: 'AuthEditProfile',
    component: () => import('@/components/auth/auth-edit-profile.vue'),
    beforeEnter: requireAuth
  },
  // 대출신청 추가 화면
  {
    path: '/loan/so_c2005',
    name: 'LoanSoc2005',
    component: () => import('@/components/loan/so_c2005.vue'),
    beforeEnter: requireAuth
  },
  // 마이페이지 메인
  {
    path: '/mypage/so_c4000',
    name: 'MyPageMain',
    component: () => import('@/components/mypage/so_c4000.vue'),
    beforeEnter: requireAuth
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 직접 URL 입력(새로고침 포함) 접근 차단: 최초 진입(from.name이 undefined)이면 무조건 홈으로
router.beforeEach((to, from, next) => {
  const isSessionExpired = sessionStorage.getItem('sessionExpired')

  // 세션 만료 플래그 감지: / 진입 시 로그인 페이지로 전환
  if (to.path === '/' && isSessionExpired) {
    return next('/auth/login')
  }

  if (from.name === undefined && to.path !== '/') {
    // 세션 만료로 /auth/login 이동 중이면 허용
    if (isSessionExpired && to.path === '/auth/login') {
      sessionStorage.removeItem('sessionExpired')
      return next()
    }
    window.history.replaceState({}, '', '/')
    return next({ path: '/' })
  }
  next()
})

// 페이지 이동 시 URL 항상 '/'로 유지
router.afterEach((to) => {
  if (window.location.pathname !== '/') {
    window.history.replaceState({}, '', '/')
  }
})

// 뒤로가기 또는 앞으로가기(popstate) 시 처리
// 상품안내(/info)와 고객센터(/support)는 뒤로가기 허용
// 대출신청(/loan), 계좌운영규칙(/account-rules), 마이페이지(/mypage)는 홈으로 이동
window.addEventListener('popstate', () => {
  const currentPath = router.currentRoute.value.path;
  
  // 뒤로가기 허용 경로: 상품안내, 고객센터, 인증 페이지(로그인/회원가입/약관)
  const allowedPaths = ['/info/', '/support/', '/auth/'];
  const isAllowedPath = allowedPaths.some(path => currentPath.startsWith(path));
  
  if (!isAllowedPath && currentPath !== '/') {
    // 대출신청, 계좌운영규칙, 마이페이지에서 뒤로가기 시 홈으로
    window.history.replaceState({}, '', '/');
    router.push({ name: 'Home' });
  } else {
    // 허용된 경로는 정상적인 뒤로가기 허용
    window.history.replaceState({}, '', '/');
  }
});

export default router
